var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedWattageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#FFA700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.45 4.5l-2.35.62-1.576-.62-2.574 8.588h2.716L9.288 19.5l5.824-8.588h-3.506L15.45 4.5z",
    fill: "#fff"
  })));
}

export default SvgLedWattageIcon;